
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["ldi-kr1zl5",classNames,staticClass],
              style: [{"animation-play-state":"running","animation-delay":"0s","background":"0 0"},style,staticStyle],
              attrs: Object.assign({"class":"ldi-kr1zl5","width":"31","height":"31","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","style":"animation-play-state:running;animation-delay:0s;background:0 0"}, attrs),
              ...rest,
            },
            children.concat([_c('svg',{staticStyle:{"transform-origin":"50px 50px 0","animation-play-state":"running","animation-delay":"0s"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 100 100","xml:space":"preserve"}},[_c('g',{staticStyle:{"transform-origin":"50px 50px 0","animation-play-state":"running","animation-delay":"0s"}},[_c('g',{staticStyle:{"transform-origin":"50px 50px 0","animation-duration":"3.2s","animation-delay":"-3.2s","animation-direction":"normal","animation-play-state":"running","-webkit-animation":"ld-breath 1s infinite","animation":"ld-breath 1s infinite"}},[_c('g',{staticStyle:{"animation-play-state":"running","animation-delay":"0s"}},[_c('g',{staticStyle:{"transform-origin":"50px 50px 0","animation-play-state":"running","animation-delay":"0s"}},[_c('path',{staticClass:"fill",staticStyle:{"animation-play-state":"running","animation-delay":"0s"},attrs:{"id":"XMLID_1312_","fill":"#007ab3","d":"M9.843 52.312L50 92.469l40.157-40.157-8.032-8.031-26.446 26.446V7.469H44.321v63.258L17.875 44.281z"}})])])])])])])
          )
        }
      }
    